function NewslettersCpn({data}){

    const {title="",image="",desc="",date=""} = data || {};
    
    return (
        <>
            <a href="/newsletters/russia-bitcoin/">
                <div className="Newsletters_cardDiv__Umfx8">
                            <div className="Newsletters_upperDiv__s72FJ">
                            <div className="Newsletters_thumbnailDiv__5Yv43">
                                <span
                                style={{
                                    boxSizing: "border-box",
                                    display: "inline-block",
                                    overflow: "hidden",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    position: "relative",
                                    maxWidth: "100%"
                                }}
                                >
                                <span
                                    style={{
                                    boxSizing: "border-box",
                                    display: "block",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    maxWidth: "100%"
                                    }}
                                >
                                    <img
                                    alt=""
                                    aria-hidden="true"
                                    src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%271024%27%20height=%27576%27/%3e"
                                    style={{
                                        display: "block",
                                        maxWidth: "100%",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0
                                    }}
                                    />
                                </span>
                                <img
                                    alt="Russia is Diving Into Bitcoin! What it Means"
                                    src={image}
                                    decoding="async"
                                    data-nimg="intrinsic"
                                    className="Newsletters_image__A6hXJ"
                                    style={{
                                    position: "absolute",
                                    inset: 0,
                                    boxSizing: "border-box",
                                    padding: 0,
                                    border: "none",
                                    margin: "auto",
                                    display: "block",
                                    width: 0,
                                    height: 0,
                                    minWidth: "100%",
                                    maxWidth: "100%",
                                    minHeight: "100%",
                                    maxHeight: "100%",
                                    objectFit: "cover"
                                    }}
                                />
                                <noscript />
                                </span>
                            </div>
                            <div className="Newsletters_detailsDiv__E_Bg6">
                                <div className="Newsletters_titleDiv__qa4WA">
                                    {title}
                                </div>
                                <div className="Newsletters_descriptionDiv__BHicH">
                                    {desc}
                                </div>
                            </div>
                            </div>
                            <div className="Newsletters_lowerDiv__K0yRb">
                            <div className="Newsletters_dateDiv__3SW_e">{date}</div>
                            </div>
                </div>
            </a>
        </>
    )
}

export default NewslettersCpn;